<template>
  <div class="notice-bar" @mouseover="pauseScroll" @mouseleave="startScroll">
    <i class="el-icon-bell" style="margin-right: 8px; color: #f90;"></i>
    <div class="notice-content" ref="noticeContent">
      <div class="notice-text" :style="{ transform: `translateX(${translateX}px)` }">
        <span v-for="(item, index) in notices" :key="index" style="margin-right: 60px;">
          {{ item }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoticeBar',
  data() {
    return {
      notices: [
        '欢迎使用AI数智全擎！'
      ],
      translateX: 0,
      timer: null,
    }
  },
  mounted() {
    this.startScroll()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    startScroll() {
      const step = 1
      this.timer = setInterval(() => {
        this.translateX -= step
        const textWidth = this.$refs.noticeContent.scrollWidth
        if (Math.abs(this.translateX) > textWidth) {
          this.translateX = this.$refs.noticeContent.offsetWidth
        }
      }, 20)
    },
    pauseScroll() {
      clearInterval(this.timer)
    }
  }
}
</script>

<style scoped>
.notice-bar {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 20px;
  background-color: #f3f3f3;
  border-bottom: 1px solid #cdcdcd;
  font-size: 14px;
  color: #666;
  overflow: hidden;
  /* width: 60%; */
  border-radius: 30px;
}

.notice-content {
  overflow: hidden;
  white-space: nowrap;
  flex: 1;
  position: relative;
}

.notice-text {
  display: inline-block;
  white-space: nowrap;
  will-change: transform;
}
</style>
